import { getChainSettings } from "../../utils/chain";
import light from "./light";

const chainSetting = getChainSettings();
const customTheme = chainSetting?.customTheme?.dark || {};

const dark = {
  ...light,
  fontPrimary: "#FFFFFF",
  fontPrimaryInverse: "#fff",
  fontSecondary: "rgba(255, 255, 255, 0.55)",
  fontTertiary: "rgba(255, 255, 255, 0.25)",
  fontQuaternary: "rgba(255, 255, 255, 0.1)",
  fontPositive: "rgba(82, 204, 138, 1)",
  fontPending: "rgba(255, 187, 55, 1)",
  fontNegative: "rgba(238, 68, 68, 1)",
  strokeBase: "#11545F",
  strokeBox: "#75C4C3",
  strokeBoxSelected: "#00A786",
  fillPanel: "#11545F",
  fillPopup: "#0A3B44",
  fillPopupHover: "#11545F",
  fillSub: "#0A3B44",
  fillBase: "#091D39",
  fillButton: "#091D39",
  fillTooltip: "rgba(9, 29, 57, 0.85)",
  fillPanelBlanket: "rgba(9, 29, 57, 0.8)",
  fillAlpha: "rgba(255, 255, 255, 0.05)",
  fillBeta: "rgba(255, 255, 255, 0.02)",
  fillGamma: "rgba(255, 255, 255, 0)",
  fillActiveBlue: "#00A786",
  fillPositive: "#52CC8A",
  fillNegative: "#ee4444",
  fillPending: "#FFBB37",
  theme500: chainSetting?.color,
  theme100: chainSetting?.colorSecondary,
  fontButtonTag: "#fff",
  ...customTheme,
};

export default dark;
